import { Action, Content, contentInfo, formatString, formatText, objectEditor, pickItemAsync, Popup, staticItemsSourceWithIcon, WebView, type IContentInfo, type ViewNode } from "@eusoft/webapp-ui";
import { Authorize } from "../../services/Authorize";
import type { Guid, IMerchantServiceView, IServiceAccessToken } from "../../entities/Commands";
import { executeAsync } from "../../services/DataService";
import { nativeApp } from "../../services/NativePayment";
import { forModel } from "@eusoft/webapp-jsx";
import { delayAsync, toKebabCase } from "@eusoft/webapp-core";
import "./EditMerchantServicePage.scss";
import { userInteraction } from "@eusoft/webapp-framework/services/UserInteraction";

interface IEditMerchantServiceArgs {
    merchantId: Guid;
    serviceName?: string;
    value?: IMerchantServiceView;
}

export class EditMerchantServicePage extends Content<IEditMerchantServiceArgs> {
    constructor() {

        super();

        this.init(EditMerchantServicePage, {
            title: "edit-service",
            style: ["panel"],
            body: forModel(this, m => <>
                {m.editor}
            </>)
        });
    }

    protected async execOAuthAsync() {

        //this.service.oAuthUri = "https://192.168.1.89:58654/OAuth/Test";

        if (!this.service.oAuthUri)
            return;


        const closeCalled = await new Promise<boolean>(res => {

            const newWindow = window.open(this.service.oAuthUri, "oauth");

            const messageHandler = (event: MessageEvent) => {

                if (event.data == "close") {
                    window.removeEventListener("message", messageHandler);
                    res(true);
                }
            }

            window.addEventListener("message", messageHandler);

            const checkClose = setInterval(() => {
                if (!newWindow || newWindow.closed) {
                    clearInterval(checkClose);
                    res(false);
                }
            }, 300);

        });

        if (!closeCalled)
            userInteraction.messageAsync("err-auth-failed-or-cancelled", "error", 3000);
        else
            userInteraction.messageAsync("msg-account-connected", "success", 3000);

        console.log(closeCalled);

        /*

        const popup = new Popup({
            title: formatText("login"),
            style: ["minimal", "oauth", toKebabCase(this.serviceName)],
            body: <WebView src={this.service.oAuthUri} onCloseRequest={() => popup.close()} />,
            actions: [{
                name: "cancel",
                text: "cancel",
                executeAsync: async () => true
            }]
        });


        let startHistoryLen = history.length;

        await popup.showAsync();

        history.go(startHistoryLen - history.length);
        */

        this.host.closeAsync(true);
    }

    protected async pairDeviceAsync() {

        const pos = nativeApp.bankPosList()
            .find(a => a.name == this.serviceName);

        if (!pos)
            return;

        await nativeApp.bankPosConfigureAsync(pos.name, {
            accessToken: this.service.accessToken
        });

        const res = await nativeApp.bankPosConnectAsync(pos.name);
        if (!res)
            userInteraction.messageAsync(formatText("err-pairing-failed"), "error", 3000);

        /*
        await nativeApp.bankPosPayAsync(pos[0].name, {
            amount: 10,
            currency: "EUR",
            description: "Ricarica",
            orderId: ""
        });*/
    }

    protected createEditor() {

        return objectEditor<this>(bld => <>
            {bld.text(m => m.friendlyName, {

            })}
            {this.serviceName == "SumUp" && <>
                {!this.service.accessToken &&
                    <Action style="text" onExecuteAsync={() => this.execOAuthAsync()}>
                        {formatText("connect-provider", "service-" + toKebabCase(this.serviceName))}
                    </Action>}

                {this.service.accessToken && <div>
                    <Action style="text" onExecuteAsync={() => this.pairDeviceAsync()}>
                        pair-device
                    </Action>
                </div>}
            </>}
        </>, {
            commitMode: "auto-inplace",
            value: this,
            style: "vertical",
            inputField: { style: "filled" },
        })
    }

    override async onLoadAsync(args: IEditMerchantServiceArgs) {

        if (!args.serviceName) {

            args.serviceName = await pickItemAsync({
                header: formatText("msg-select-service"),
                style: ["select-service"],
                itemsSource: staticItemsSourceWithIcon(
                    ["SumUp", "SumUp", <img className="icon sum-up" style-width="32px" src="/img/SumUp.png" />]
                )
            });

            if (!args.serviceName)
                return false;
        }

        this.serviceName = args.serviceName;
        this.merchantId = args.merchantId;
        this.friendlyName = args.value?.name ?? args.serviceName;
        this.serviceId = args.value?.id;

        this.service = await executeAsync("GetServiceAccessToken", {
            merchantId: this.merchantId,
            serviceName: this.serviceName
        });


        if (this.service?.accessToken && !this.serviceId) {
            userInteraction.messageAsync(formatText("msg-service-already-added"), "warning", 3000);
            return false;
        }

        this.editor = this.createEditor();

        this.title = formatString(this.serviceId  ? "edit-item" : "add-item", "service-" + toKebabCase(this.serviceName));

        return true;
    }

    editor: ViewNode;

    merchantId: Guid;

    serviceName: string;

    service: IServiceAccessToken;

    friendlyName: string;

    serviceId: Guid;


    static override info = contentInfo({
        name: "merchant-service-edit",
        route: "/merchant/{merchantId}/services/{serviceName}",
        factory: () => new EditMerchantServicePage(),
        features: [
            Authorize(a => a.businessAccount()
                .resource("Merchant", "edit")
            )
        ]
    } as IContentInfo<IEditMerchantServiceArgs, EditMerchantServicePage>);
}
